import { SelectAutocompletePrediction } from '@search-bar/entities/select-autocomplete-prediction';
import { SearchData } from '@shared/base-search-bar/entities/search-data';
import { VehicleSearchPayload } from '@autos/entities/vehicle-search.payload';
import { VehicleResultsPayload } from '@autos/entities/vehicle-results.payload';
import { RangeFilterPayload } from '@shared/filters/entities/range-filter';
import { PriceFilter } from '@shared/filters/entities/fetch-filters.response';
import { SorterTypes } from '@shared/filters/entities/sorter-options';

export enum AutoFilterTypes {
  AirConditioned = 'AirConditioned',
  Company = 'Company',
  Doors = 'Doors',
  FuelType = 'FuelType',
  MaxPax = 'MaxPax',
  MaxPrice = 'MaxPrice',
  MinPrice = 'MinPrice',
  Model = 'Model',
  NextPage = 'NextPage',
  OrderCriteria = 'OrderCriteria',
  Price = 'Price',
  PriceFrom = 'PriceFrom',
  PriceRanges = 'PriceRanges',
  PriceTo = 'PriceTo',
  Provider = 'Provider',
  Sort = 'Sort',
  SpecialRate = 'SpecialRate',
  Tags = 'Tags',
  TransmissionType = 'TransmissionType',
  UnlimitedMileage = 'UnlimitedMileage',
  VehicleCategory = 'VehicleCategory',
}

export enum TransmissionTypes {
  Manual = 'MANUAL',
  Automatic = 'AUTOMATIC'
}

export enum AutoPriceRangeTypes {
  PriceFrom = 'PriceFrom',
  PriceTo = 'PriceTo'
}

export type AutoFilterApplier = Readonly<{
  input?: AutoFilterInputTypes,
  removable?: boolean;
  type: AutoFilterTypes,
  value: AutoFilterApplierValue,
  widget?: Readonly<{ index?: number; }>;
}>;

export type AutoFilterApplierValue =
string | number | string[] | number[] | PriceFilter | AutoCheckboxFilter[] | RangeFilterPayload | FilterSorter[];

export interface AutoCheckboxFilter {
  Text: string;
  Count: number;
}

export enum AutoFilterInputTypes {
  Checkbox = 'checkbox',
  Range = 'range',
  Radio = 'radio',
  Input = 'input'
}

export type FilterSorterCriterias = Readonly<{
  OrderCriteria: SorterTypes,
  OrderDesc: boolean,
}>;

export type FilterSorter = Readonly<{
  Label: string,
}>&FilterSorterCriterias;


export enum AutoFilterProvider {
  AutoResults = 'AUTORESULTS',
  AutoMap = 'AUTOMAP'
}

export interface SearchParameters {
  params: VehicleSearchPayload;
  query: string[];
  filters: VehicleResultsPayload;
  searchData: SearchData;
}

export interface NavigateParameters {
  placePickUp: SelectAutocompletePrediction;
  placeDropOff: SelectAutocompletePrediction;
}
